import CryptoJS from 'crypto-js'
const userSecretKey = process.env.REACT_APP_USERLOCALSTORAGE_ENCRYPTION_KEY

export const removeUserFromLocalStorage = () => {
	const user = 'user'
	localStorage.removeItem(user)
}
export const addUserToLocalStorage = (user) => {
	const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(user), userSecretKey).toString()
	localStorage.setItem('user', encryptedData)
}

export const getUserFromLocalStorage = () => {
	try {
		const storedData = localStorage.getItem('user')
		if (storedData) {
			const decryptedData = CryptoJS.AES.decrypt(storedData, userSecretKey).toString(CryptoJS.enc.Utf8)
			return JSON.parse(decryptedData)
		}
		return null
	} catch (error) {
		console.error('Error decrypting data:', error)
		return null
	}
}

export const getUserInitials = (fullName) => {
	return fullName
		? fullName
				.split(' ')
				.map((word) => word[0].toUpperCase())
				.join('')
		: ''
}

export const fallbackImageStyle = {
	backgroundColor: '#FFC0CB', // Pink background
	color: 'white',
	width: '100%',
	height: '170px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	fontSize: '2rem',
	fontWeight: 'bold',
	borderRadius: '1rem',
}

// Truncate function
export const truncateText = (text, length) => {
	if (text?.length > length) {
		return text.substring(0, length) + '...'
	}
	return text
}

export const truncateHtmlText = (html = '', limit = 35) => {
	if (!html) return ''

	const tempDiv = document.createElement('div')
	tempDiv.innerHTML = html
	const plainText = tempDiv.textContent || tempDiv.innerText || ''

	return truncateText(plainText, limit)
}
